import { MuteText } from '@elements/Common';
import { cn } from '@skupreme/shared/ui';
import type { ComponentPropsWithoutRef } from 'react';

export function RenderMutedDays({ days, renderMuted = true }) {
  const label = `Day${days !== 1 ? 's' : ''}`;
  const daysLabel = renderMuted ? (
    <MuteText className="sk:pr-0!">{label}</MuteText>
  ) : (
    <span className="sk:pl-1! sk:pr-0!">{label}</span>
  );

  return (
    <>
      {isNaN(days) ? 0 : days}
      {daysLabel}
    </>
  );
}

type DivProps = ComponentPropsWithoutRef<'div'>;

/*
 * The formula breakdowns are rendered inside DarkPopup, whose bubble keeps the
 * legacy dark fill in both themes, so their rules and muted text are tints of
 * white rather than kit tokens that would flip with the theme.
 */
const POPUP = cn(
  'sk:max-h-[calc(100vh-200px)]',
  'sk:[&_td]:whitespace-nowrap sk:[&_td]:px-[5px] sk:[&_td]:py-0',
  'sk:[&_span]:whitespace-nowrap sk:[&_span]:px-[5px] sk:[&_span]:py-0',
  'sk:[&_.appendix_td]:whitespace-break-spaces sk:[&_.appendix_td]:align-top sk:[&_.appendix_td]:text-white/60',
  'sk:[&_.appendix_span]:whitespace-break-spaces sk:[&_.appendix_span]:align-top sk:[&_.appendix_span]:text-white/60',
  'sk:[&_.appendix_.description]:w-4/5',
  'sk:[&_.total]:border-t sk:[&_.total]:border-white/20',
  'sk:[&_.mute-span]:whitespace-break-spaces',
  'sk:[&_.divider]:h-px sk:[&_.divider]:w-full sk:[&_.divider]:bg-white/60',
  'sk:[&_.light-border]:h-px sk:[&_.light-border]:w-full sk:[&_.light-border]:bg-white/20',
  'sk:[&_.power]:relative',
  'sk:[&_.to-power]:absolute sk:[&_.to-power]:-top-[5px] sk:[&_.to-power]:-right-1.5 sk:[&_.to-power]:text-[9px]',
);

/** Pass `small-height` in className to cap it at 400px, for the short popups. */
export function StyledPopup({ className, ...props }: DivProps) {
  const smallHeight = className?.split(' ').includes('small-height');
  return (
    <div
      className={cn(POPUP, smallHeight && 'sk:max-h-[400px]', className)}
      {...props}
    />
  );
}

export const parseNumber = value => (value > 0 ? value : 0);

export function FormulaContainer({ className, ...props }: DivProps) {
  return (
    <div
      className={cn(
        'sk:flex sk:gap-x-2.5 sk:text-[15px] sk:font-bold sk:whitespace-nowrap sk:[&_.pointer]:cursor-pointer',
        className,
      )}
      {...props}
    />
  );
}
